<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<figure class="figure" id="fig1">
<p class="fig"><a class="page" id="pix"></a><a class="page" id="px"></a><img alt="" height="402" src="images/chi-cresswell-fig01_300ppi_bw.jpeg" width="600"/></p>
<p class="figh"><span class="fighn">FIGURE 1.</span></p>
<p class="figh">Corner of Maxwell and Halsted Streets, Chicago, April 1941. Photo by Russell Lee. LC-USF33-012984-M5. Library of Congress, Prints and Photographs Division, FSA/OWI Collection.</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-cresswell-0007.vue?8708bdf0